<svg
  width="21"
  height="23"
  viewBox="0 0 21 23"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-labelledby="recat-icon-title recat-icon-desc"
  role="img"
>

  <title id="recat-icon-title">Recategorisation icon</title>
  <desc id="recat-icon-desc">This is a recategorisation icon.</desc>
  <path
    class="fill"
    fill="white"
    d="M8.53125 5.91429C6.26862 5.91429 4.09866 6.81433 2.49874 8.41643C0.898825 10.0185 0 12.1914 0 14.4571C0 16.7229 0.898825 18.8958 2.49874 20.4979C4.09866 22.1 6.26862 23 8.53125 23H13.125V20.3714H8.53125C5.25 20.3714 2.625 17.7429 2.625 14.4571C2.625 11.1714 5.25 8.54286 8.53125 8.54286H15.9731L11.9306 12.604L13.7812 14.4571L21 7.22857L13.7812 0L11.9175 1.85314L15.9731 5.91429H8.53125ZM18.375 20.3714H15.75V23H18.375V20.3714Z"
  />
</svg>
